<template>
  <div>
    <cui-reset-password />
  </div>
</template>
<script>
import CuiResetPassword from '@/components/cleanui/system/Auth/ResetPassword'
export default {
  components: {
    CuiResetPassword,
  },
}
</script>
